export const appStyles = {
	activeTheme: 'BLUE_THEME',
	activeDir: 'ltr',
	headerHeight: '60px',
	topBarHeight: '40px',
	sideBarWidth: '375px',
}
export default appStyles